import React from 'react';
import { IntersectionOptions, useInView } from 'react-intersection-observer';

export const withIntersectionObserver =
  <T,>(
    ReactComponent: React.FC<T>,
    intersectionObserverOptions?: IntersectionOptions,
  ) =>
  (
    props: React.PropsWithChildren<T & { isInView?: boolean }>,
  ): React.ReactElement<T> => {
    const { ref, inView } = useInView(intersectionObserverOptions);
    return (
      <div ref={ref}>
        <ReactComponent isInView={inView} {...props} />
      </div>
    );
  };
